import { cn } from "@/lib/utils";

export const Logo = ({ className, showWordmark = true }) => {
    return (
        <a href="#top" className={cn("group inline-flex items-center gap-2.5", className)} aria-label="Web Me Up">
            <div className="relative flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-primary shadow-glow transition-transform duration-300 group-hover:scale-105">
                <span className="font-display text-lg font-bold text-primary-foreground">W</span>
                <span className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-success ring-2 ring-background" />
            </div>
            {showWordmark && (
                <div className="flex flex-col leading-none">
                    <span className="font-display text-base font-semibold tracking-tight text-foreground">
                        Web Me Up<span className="text-primary">.</span>
                    </span>
                    <span className="mt-0.5 text-[10px] font-medium uppercase tracking-[0.18em] text-muted-foreground">
                        Tools for agencies
                    </span>
                </div>
            )}
        </a>
    );
};

export default Logo;
